/* Inngangen til all frontend-kode. esbuild bygger denne til én fil, pluss en
 * egen fil med Three.js som bare hentes når fjordscenen faktisk skal kjøres.
 *
 * Alt bygger på progressiv forbedring: markeringen fra Jinja2 er fullverdig
 * innhold i seg selv, og modulene her legger oppførsel oppå. Feiler noe her,
 * står siden fortsatt lesbar. Hver seksjonsmodul sjekker selv om den har noe
 * å gjøre på siden, så de samme modulene kan kjøre på alle tre sidene. */

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import { delOppTekst } from './kjerne/tekst.js';
import { startScroll, stoppRulling, startRulling, koblAnkerlenker } from './kjerne/scroll.js';
import { startHeader } from './kjerne/header.js';
import { startMeny } from './kjerne/meny.js';
import { startMarkor } from './kjerne/markor.js';
import { startTraad } from './kjerne/traad.js';
import { meldBesok } from './kjerne/besok.js';

import { startHero } from './hero/index.js';
import { startManifest } from './seksjoner/manifest.js';
import { startTestland } from './seksjoner/testland.js';
import { startOmrader } from './seksjoner/omrader.js';
import { startSkreddersom } from './seksjoner/skreddersom.js';
import { startMarquee } from './seksjoner/marquee.js';
import { startSporbarhet } from './seksjoner/sporbarhet.js';
import { startTidslinje } from './seksjoner/tidslinje.js';
import { startKontakt } from './seksjoner/kontakt.js';
import { startOverskrifter } from './seksjoner/overskrifter.js';

/* Først, så besøket telles selv om noe lenger ned skulle feile. */
meldBesok();

gsap.registerPlugin(ScrollTrigger);

delOppTekst();
startScroll();

/* Headeren trenger å vite om menyen er åpen, og menyen trenger å kunne vise
   headeren. De bindes sammen etter at begge finnes. */
let meny = { erApen: () => false, lukk: () => {} };
const header = startHeader(() => meny.erApen());
meny = startMeny({ stoppRulling, startRulling, visHeader: header.vis });

koblAnkerlenker(() => meny.lukk());
startMarkor();
startTraad();

startHero();
startManifest();
startTestland();
startOmrader();
startSkreddersom();
startMarquee();
startSporbarhet();
startTidslinje();
startKontakt();
startOverskrifter();

/* Målene ScrollTrigger regnet ut kan endre seg når bilder og skrift er inne. */
addEventListener('load', () => ScrollTrigger.refresh());
document.fonts?.ready.then(() => ScrollTrigger.refresh());
